var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advert-box",on:{"click":_vm.dos}},[_c('div',{staticClass:"wbanner"},[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":_vm.advertTime,"indicator-color":"white"}},_vm._l((_vm.advertWai),function(item,index){return _c('van-swipe-item',{key:item.id},[_c('img',{staticClass:"wadv",attrs:{"src":item}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }